import { CSSProperties, FC, PropsWithChildren, useEffect, useMemo, useState } from 'react'
import Image, { ImageLoader, ImageLoaderProps } from 'next/image'
import Link from 'next/link'
import clsx from 'clsx'

interface PdImageProps {
  src: string
  h5Src?: string
  className?: string
  enableMask?: boolean
  width: string /* image viewport width */
  height?: string /* image viewport height */
  object?: 'contain' | 'fill' | 'cover'
  objectPosition?: 'top' | 'center' | 'bottom'
  alt?: string
  enableHoverScale?: boolean
  linkHref?: string /* 跳转链接 */
  useLoader?: boolean /* 是否使用loader来适配pc,h5的图片 */
  placeholder?: 'empty' | 'blur'
  priority?: boolean
  maskStyle?: CSSProperties
}

const imageLoader = ({ src, h5Src, width, quality }: ImageLoaderProps & { h5Src?: string }) => {
  // const indexOfQuerySep = src.lastIndexOf('?')
  if (width > 1200) {
    return src
  }

  return h5Src || src

  /* h5 */
  // const indexOfExtendDot = src.lastIndexOf('.')
  // const splitedSrc = src.split('')
  // splitedSrc.splice(indexOfExtendDot, 0, '_h5')
  // const h5Src = splitedSrc.join('')
  // return h5Src
}

const rawImageLoader: ImageLoader = ({ src, width, quality }: ImageLoaderProps) => {
  return src
}

const PdImage: FC<PropsWithChildren<PdImageProps>> = (props: PropsWithChildren<PdImageProps>) => {
  const { width, height, h5Src, className, alt, placeholder = 'blur', priority, maskStyle } = props
  const styles = {
    width,
    height,
  }

  return (
    <div className={clsx('relative w-full h-full overflow-hidden group', className)} style={styles}>
      {/* 9999999px 足够大，让图片高度和父容器的高度相同*/}
      {!!props.src && props.src !== 'undefined' && (
        <div className="h-full w-full">
          {props.linkHref && (
            <Link href={props.linkHref} passHref={true}>
              <a>
                <Image
                  className={[
                    props.enableHoverScale ? 'group-hover:scale-110 transition-all ease-in-out duration-700' : '',
                    'cursor-pointer',
                  ].join(' ')}
                  src={props.src}
                  layout="fill"
                  objectFit={props.object || 'cover'}
                  objectPosition={props.objectPosition === void 0 ? 'center' : props.objectPosition}
                  alt={alt || ''}
                  quality={100}
                  priority={priority ?? false}
                  placeholder={placeholder}
                  blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAQAAAAnOwc2AAAAEUlEQVR42mP8P5MBAzAOZUEAIJwP+02hnz0AAAAASUVORK5CYII="
                  loading={priority ? void 0 : 'lazy'}
                  sizes="(max-width: 1200px) 300px, 100vw"
                  loader={
                    props.useLoader
                      ? ({ src, width, quality }) => imageLoader({ src, h5Src: props.h5Src, width, quality })
                      : rawImageLoader
                  }
                />
              </a>
            </Link>
          )}
          {!props.linkHref && (
            <Image
              className={[
                props.enableHoverScale ? 'group-hover:scale-110 transition-all ease-in-out duration-700' : '',
              ].join(' ')}
              src={props.src}
              layout="fill"
              objectFit={props.object || 'cover'}
              objectPosition={props.objectPosition === void 0 ? 'center' : props.objectPosition}
              alt={alt || ''}
              quality={100}
              placeholder={placeholder}
              blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAQAAAAnOwc2AAAAEUlEQVR42mP8P5MBAzAOZUEAIJwP+02hnz0AAAAASUVORK5CYII="
              priority={priority ?? false}
              loading={priority ? void 0 : 'lazy'}
              sizes="(max-width: 1200px) 300px, 100vw"
              loader={
                props.useLoader
                  ? ({ src, width, quality }) => imageLoader({ src, h5Src: props.h5Src, width, quality })
                  : rawImageLoader
              }
            />
          )}
        </div>
      )}
      {props.enableMask && (
        <div
          className="absolute w-full h-full inset-0 pointer-events-none"
          style={maskStyle || { backgroundColor: 'rgba(0,0,0, .2)' }}
        ></div>
      )}
      {props.children}
    </div>
  )
}
export default PdImage
export type { PdImageProps }
